import React, { memo } from 'react';
import PropTypes from 'prop-types';
import style from '../../style/components/profile/WalletSectionCard.module.scss';

const WalletSectionCard = ({
  children,
  title,
  icon,
  className,
  id,
  noDivider,
}) => (
  <section id={id} className={`${style.card} ${className || ''}`}>
    {title && (
      <div className={`${style.titleRow} ${noDivider ? style.noDivider : ''}`}>
        {icon && <span className={style.icon}>{icon}</span>}
        <h3 className={style.title}>{title}</h3>
      </div>
    )}
    {children}
  </section>
);

WalletSectionCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  icon: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  noDivider: PropTypes.bool,
};

WalletSectionCard.defaultProps = {
  children: null,
  title: undefined,
  icon: undefined,
  className: undefined,
  id: undefined,
  noDivider: false,
};

export default memo(WalletSectionCard);
